var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Your order will be on its way. Receipt of this purchase will be sent to your email")])}
var staticRenderFns = []

export { render, staticRenderFns }